export const customerPublicBtn= {
  methods: {
    excelGlanceList:function (journalType,menuId) {
      this.journalType=journalType;
      this.menuId=menuId;
      this.showExcelExport=true;
    },
    closeExcelExport:function (flag,operateStyle,exportSign) {
      this.showExcelExport=false;
      if (flag) {
        let url="customer/exportCustomer.json";
        if(exportSign=="service"){
          url="service/exportService.json";
        }else if(exportSign=="taskCustom" && operateStyle=='1'){
          url="customer/exportCallTaskCustomer.json"
        }
        if (operateStyle=='0'){//选中结果
          if (this.checkIds.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可导出的数据"
            });
            return false;
          }
          let param={
            id:this.checkIds.toString(),
            journalType:this.journalType+"按选中结果导出",
            menuId:this.menuId,
            customerScope:this.formValidate.customerScope,
            customerState:this.formValidate.customerState
          };
          this.$Loading.start();
          this.operateExcelExport(param,url)
        }
        if (operateStyle=='1'){//按搜索结果
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可导出的数据"
            });
            return false;
          }
          if(!this.queryParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再导出"
            });
            return false;
          }
          // let param={
          //   journalType:this.journalType+"按搜索结果导出",
          //   menuId:this.menuId,
          //   customerScope:this.formValidate.customerScope,
          //   customerState:this.formValidate.customerState
          // };
          // this.getParam(this.formValidate,param,exportSign);

          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];

          this.$set(this.queryParam, 'type', operateStyle);
          this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果导出");
          this.$set(this.queryParam, 'menuId', this.menuId);
          this.$Loading.start();
          this.operateExcelExport(this.queryParam,url)
        }
      }
    },
    operateExcelExport:function (param,url) {
      let that=this;
      let xmlResQuest = new XMLHttpRequest();
      xmlResQuest.open("POST", this.baseURL+url, true);
      xmlResQuest.setRequestHeader("Content-type", "application/json");
      xmlResQuest.setRequestHeader("Authorization", "Bearer "+localStorage.getItem("token"));
      xmlResQuest.responseType = "blob";
      xmlResQuest.send(JSON.stringify(param));
      xmlResQuest.onload = function () {
        if (this.status== 200 || this.status==666) {// 判断请求状态码，看请求是否成功执行
          let content = xmlResQuest.response;
          let eLink = document.createElement('a');
          eLink.download = decodeURI(xmlResQuest.getResponseHeader("filename"));
          eLink.style.display = 'none';
          let blob = new Blob([content]);
          eLink.href = URL.createObjectURL(blob);
          document.body.appendChild(eLink);
          eLink.click();
          document.body.removeChild(eLink);
          that.$Loading.finish();
          return false;
        }
        that.$Loading.error();
        that.$Modal.info({
          title: '提示',
          content: "导出失败"
        });
      };
    },
    getTime:function(time){
      let month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
      let Date=time.getDate()<10?"0"+time.getDate():time.getDate();
      let Hours=time.getHours()<10?"0"+time.getHours():time.getHours();
      let Minutes=time.getMinutes()<10?"0"+time.getMinutes():time.getMinutes();
      let Seconds=time.getSeconds()<10?"0"+time.getSeconds():time.getSeconds();
      let datetime=time.getFullYear() + month + Date + Hours + Minutes + Seconds;
      return datetime
    },
    closeShowPage:function (flag,result) {
      this.showPage=false;
      if(flag){

        let selectedResult=result.selectedResult;
        let that=this;
        let sign=result.sign;
        let param={
          id:result.id,
          operateType:sign=="0"?"allot":"share",
          journalType: this.journalType,
          menuId: this.menuId,
          empId:result.shareStyle=="0"?result.empId:result.empId+"-"+result.shareCustomerCount,
          isCallPlan :result.isCreatedPlan ,
          allotType:result.shareStyle,
          callPlanName:result.planName
        };
        if(selectedResult!="0"){//搜索
          // param={
          //   empId:result.shareStyle=="0"?result.empId:result.empId+"-"+result.shareCustomerCount,
          //   pageNum:this.currentPage,
          //   pageSize:this.pageSize,
          //   customerScope:this.formValidate.customerScope,
          //   customerState:this.formValidate.customerState,
          //   operateType:result.sign=="0"?"allot":"share",
          //   isCallPlan :result.isCreatedPlan,
          //   allotType:result.shareStyle,
          //   callPlanName:result.planName,
          //   journalType: this.journalType,
          //   menuId: this.menuId,
          // };
          // this.getParam(this.formValidate,param);
          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];

          this.$set(this.queryParam, 'empId', result.shareStyle=="0"?result.empId:result.empId+"-"+result.shareCustomerCount);
          this.$set(this.queryParam, 'operateType', result.sign=="0"?"allot":"share");
          this.$set(this.queryParam, 'isCallPlan', result.isCreatedPlan);
          this.$set(this.queryParam, 'allotType', result.shareStyle);
          this.$set(this.queryParam, 'callPlanName', result.planName);
          this.$set(this.queryParam, 'journalType', this.journalType);
          this.$set(this.queryParam, 'menuId', this.menuId);
          param = this.queryParam;
        }
        this.$http.post("customer/operateCustomer.json",param) .then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.$Message.info(sign=='0'?"分配成功":"共享成功");
          that.spinShow=true;
          that.initSearch();
        })
      }
    },
    //分配
    distributionCustomer:function (journalType,menuId) {
      this.sign="0";
      this.journalType=journalType;
      this.menuId=menuId;
      this.showPage=true;
    },
    //共享
    shareCustomer:function (journalType,menuId) {
      this.sign="1";
      this.journalType=journalType;
      this.menuId=menuId;
      this.showPage=true;
    },
    closeImport:function (flag) {
      this.showImportPop=false;
      if(flag){
        this.initSearch();
      }
    },
    excelImportList:function (journalType,menuId) {
      this.journalType=journalType;
      this.menuId=menuId;
      this.showImportPop=true;
    },
    moreBtn:function (name,title) {
      this.journalType='客户管理=>全部客户=>'+title;
      this.menuId=name;
      this.showPublicPop=true;
      this.popSign=title;
    },
    closePublicPop:function (flag,operateStyle,popSign) {
        this.showPublicPop=false;
        let param={
          id:this.checkIds.toString(),
          journalType:this.journalType+"按选中结果"+popSign,
          menuId:this.menuId,
          customerScope:this.formValidate.customerScope,
        };
        if(flag){
          let title=popSign;
          let lastTitle="的客户";
          if(popSign=="解除客户分配"){
            title="解除分配";
          }
          if(popSign=="解除客户共享"){
            title="解除共享";
          }
          if(popSign=="申请客户"){
            title="申请";
          }
          if(popSign=="放弃客户"){
            title="放弃";
          }
          if(popSign=="批量删除服务记录"){
            title="批量删除";
            lastTitle="的服务记录";
          }
          if(popSign=="服务记录导出"){
            title="导出";
            lastTitle="的服务记录";
          }
          if (operateStyle=='0'){//选中结果
            if (this.checkIds.length==0){
              this.$Modal.info({
                title:'提示',
                content:"请选择要"+title+lastTitle
              });
              return false;
            }
          }
          if (operateStyle=='1'){//按搜索结果
            if(this.contentList.length==0){
              this.$Modal.info({
                title:'提示',
                content:"当前没有可"+title+lastTitle
              });
              return false;
            }
            // param={
            //   journalType:this.journalType+"按搜索结果"+popSign,
            //   menuId:this.menuId,
            //   id:"",
            //   customerScope:this.formValidate.customerScope,
            //   customerState:this.formValidate.customerState
            // };
            // this.getParam(this.formValidate,param);
            param = this.queryParam;
          }
          this.pubInterfaceCall(param,popSign)
        }
    },
    pubInterfaceCall:function (param,popSign) {
      let that=this;
      let url="customer/operateCustomer.json";
      if(popSign=="解除客户分配"){
        param["operateType"]="cancelAllot";
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定解除分配",
          onOk: () => {
            that.doOk(param,popSign,url);
          }
        });
      }
      if(popSign=="转到公海客户"){
        param["operateType"]="public";
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定转到公海",
          onOk: () => {
            that.doOk(param,popSign,url);
          }
        });
      }
      if(popSign=="解除客户共享"){
        param["operateType"]="cancelShare";
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定解除共享",
          onOk: () => {
            that.doOk(param,popSign,url);
          }
        });
      }
      if(popSign=="放弃客户"){
        param["operateType"]="giveUp";
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定放弃",
          onOk: () => {
            that.doOk(param,popSign,url);
          }
        });
      }
      if(popSign=="申请客户"){
        param["operateType"]="applyCustomer";
        url="openSea/doApplyForCustomer.json";
        this.doOk(param,popSign,url);
      }
      if(popSign=="服务记录导出"){
        url="service/exportService.json";
        this.doOk(param,popSign,url);
      }
      if(popSign=="批量删除服务记录"){
        url="service/deleteService.json";
        this.doOk(param,popSign,url);
      }
    },
    doOk:function (param,popSign,url) {
      let that=this;
      this.$http.post(url,param) .then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.$Message.info("操作成功");
        that.spinShow=true;
        if("service/deleteService.json" == url){
          that.closeServiceRecord(true);
          return;
        }
        that.initSearch();
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/js/CustomerPublicBtn.js